import React from 'react';
import { useTranslation } from 'react-i18next';

// 導入團隊成員圖片
import 創辦人 from '../assets/images/創辦人.png';
import 設計總監 from '../assets/images/設計總監.png';
import 專案經理 from '../assets/images/專案經理.png';
import 技術總監 from '../assets/images/技術總監.png';
import 工程師1 from '../assets/images/工程師1.png';
import 工程師2 from '../assets/images/工程師2.png';
import 工程師3 from '../assets/images/工程師3.png';
import 工程師4 from '../assets/images/工程師4.png';
import 開會 from '../assets/images/開會.png';

const About = () => {
  const { t } = useTranslation();

  return (
    <>
      {/* 頁面標題 */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h1 className="display-4">{t('aboutUs')}</h1>
              <p className="lead">了解凱撒數位科技的故事、使命和願景</p>
            </div>
          </div>
        </div>
      </section>

      {/* 公司介紹 */}
      <section className="py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <img
                src={開會}
                alt="團隊討論"
                className="img-fluid rounded shadow about-img"
              />
            </div>
            <div className="col-lg-6 about-content">
              <h2>我們的故事</h2>
              <p>凱撒數位科技（CaesarTechStudio）成立於2023年，是由一群充滿熱情的科技專業人士共同創立的數位科技公司。我們的創辦團隊擁有豐富的軟體開發、用戶體驗設計和數位行銷經驗，致力於為企業提供全方位的數位解決方案。</p>
              <p>我們相信，科技應該為人類創造更美好的生活和工作體驗。因此，我們專注於開發易用、高效且具創新性的數位產品，幫助企業在數位時代保持競爭力。</p>
            </div>
          </div>
        </div>
      </section>

      {/* 使命和願景 */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="row">
            <div className="col-md-6 mb-4 mb-md-0">
              <div className="card h-100 border-0 shadow">
                <div className="card-body p-4">
                  <h3 className="mb-4 text-primary">{t('ourMission')}</h3>
                  <p>{t('missionDesc')}</p>
                  <ul className="list-unstyled">
                    <li className="mb-2"><i className="fas fa-check-circle text-success mr-2"></i> 提供卓越的用戶體驗</li>
                    <li className="mb-2"><i className="fas fa-check-circle text-success mr-2"></i> 開發創新的數位解決方案</li>
                    <li className="mb-2"><i className="fas fa-check-circle text-success mr-2"></i> 協助企業實現數位轉型</li>
                    <li className="mb-2"><i className="fas fa-check-circle text-success mr-2"></i> 與客戶建立長期合作關係</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="card h-100 border-0 shadow">
                <div className="card-body p-4">
                  <h3 className="mb-4 text-primary">{t('ourVision')}</h3>
                  <p>{t('visionDesc')}</p>
                  <ul className="list-unstyled">
                    <li className="mb-2"><i className="fas fa-arrow-circle-right text-primary mr-2"></i> 成為數位創新的領導者</li>
                    <li className="mb-2"><i className="fas fa-arrow-circle-right text-primary mr-2"></i> 培養最優秀的科技人才</li>
                    <li className="mb-2"><i className="fas fa-arrow-circle-right text-primary mr-2"></i> 開發改變產業的數位產品</li>
                    <li className="mb-2"><i className="fas fa-arrow-circle-right text-primary mr-2"></i> 為客戶創造最大的商業價值</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 核心價值 */}
      <section className="py-5">
        <div className="container">
          <div className="section-title">
            <h2>我們的核心價值</h2>
            <p>這些價值觀指引著我們的日常工作和決策</p>
          </div>

          <div className="row">
            <div className="col-md-4 mb-4">
              <div className="feature-box text-center">
                <i className="fas fa-lightbulb"></i>
                <h3>創新</h3>
                <p>我們不斷探索新技術和創意，為客戶提供最具前瞻性的解決方案。</p>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="feature-box text-center">
                <i className="fas fa-users"></i>
                <h3>協作</h3>
                <p>我們相信團隊合作的力量，與客戶密切協作，共同創造最佳成果。</p>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="feature-box text-center">
                <i className="fas fa-shield-alt"></i>
                <h3>誠信</h3>
                <p>我們以誠信和透明為本，在所有業務活動中恪守最高的道德標準。</p>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="feature-box text-center">
                <i className="fas fa-rocket"></i>
                <h3>卓越</h3>
                <p>我們追求卓越品質，確保每個專案都符合最高標準。</p>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="feature-box text-center">
                <i className="fas fa-heart"></i>
                <h3>客戶至上</h3>
                <p>我們將客戶的需求和成功放在首位，提供超出期望的服務。</p>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="feature-box text-center">
                <i className="fas fa-sync-alt"></i>
                <h3>持續學習</h3>
                <p>我們不斷學習和成長，保持對最新技術和行業趨勢的敏銳度。</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 團隊成員 */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="section-title">
            <h2>我們的團隊</h2>
            <p>由經驗豐富的專業人士組成的團隊，致力於為您提供最佳的數位解決方案</p>
          </div>

          <div className="row">
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="card border-0 shadow h-100">
                <img
                  src={創辦人}
                  alt="創辦人"
                  className="card-img-top"
                />
                <div className="card-body text-center">
                  <h5 className="card-title mb-0">KarasHuang</h5>
                  <p className="text-muted">執行長 / 創辦人</p>
                  <p className="card-text">擁有15年軟體開發和技術管理經驗</p>
                  {/* <div className="social-icons">
                    <a href="#" className="text-dark mr-2"><i className="fab fa-linkedin-in"></i></a>
                    <a href="#" className="text-dark mr-2"><i className="fab fa-twitter"></i></a>
                    <a href="#" className="text-dark"><i className="fas fa-envelope"></i></a>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="card border-0 shadow h-100">
                <img
                  src={設計總監}
                  alt="設計總監"
                  className="card-img-top"
                />
                <div className="card-body text-center">
                  <h5 className="card-title mb-0">KarasHuang</h5>
                  <p className="text-muted">設計總監</p>
                  <p className="card-text">擁有10年用戶體驗和界面設計經驗，專注於創造直觀且美觀的數位產品。</p>
                  {/* <div className="social-icons">
                    <a href="#" className="text-dark mr-2"><i className="fab fa-linkedin-in"></i></a>
                    <a href="#" className="text-dark mr-2"><i className="fab fa-twitter"></i></a>
                    <a href="#" className="text-dark"><i className="fas fa-envelope"></i></a>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="card border-0 shadow h-100">
                <img
                  src={技術總監}
                  alt="技術總監"
                  className="card-img-top"
                />
                <div className="card-body text-center">
                  <h5 className="card-title mb-0">KarasHuang</h5>
                  <p className="text-muted">技術總監</p>
                  <p className="card-text">全端開發專家，擅長系統架構設計和技術選型，確保產品的穩定性和可擴展性。</p>
                  {/* <div className="social-icons">
                    <a href="#" className="text-dark mr-2"><i className="fab fa-linkedin-in"></i></a>
                    <a href="#" className="text-dark mr-2"><i className="fab fa-twitter"></i></a>
                    <a href="#" className="text-dark"><i className="fas fa-envelope"></i></a>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="card border-0 shadow h-100">
                <img
                  src={專案經理}
                  alt="專案經理"
                  className="card-img-top"
                />
                <div className="card-body text-center">
                  <h5 className="card-title mb-0">KarasHuang</h5>
                  <p className="text-muted">專案經理</p>
                  <p className="card-text">擅長專案管理和客戶溝通，確保專案按時高質量地交付，並維護客戶關係。</p>
                  {/* <div className="social-icons">
                    <a href="#" className="text-dark mr-2"><i className="fab fa-linkedin-in"></i></a>
                    <a href="#" className="text-dark mr-2"><i className="fab fa-twitter"></i></a>
                    <a href="#" className="text-dark"><i className="fas fa-envelope"></i></a>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="card border-0 shadow h-100">
                <img
                  src={工程師1}
                  alt="前端工程師"
                  className="card-img-top"
                />
                <div className="card-body text-center">
                  <h5 className="card-title mb-0">KarasHuang三號</h5>
                  <p className="text-muted">前端工程師</p>
                  <p className="card-text">精通 React、HTML、CSS、JavaScript 等前端框架，致力於開發美觀且高性能的用戶界面。</p>
                  {/* <div className="social-icons">
                    <a href="#" className="text-dark mr-2"><i className="fab fa-linkedin-in"></i></a>
                    <a href="#" className="text-dark mr-2"><i className="fab fa-twitter"></i></a>
                    <a href="#" className="text-dark"><i className="fas fa-envelope"></i></a>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="card border-0 shadow h-100">
                <img
                  src={工程師2}
                  alt="後端工程師"
                  className="card-img-top"
                />
                <div className="card-body text-center">
                  <h5 className="card-title mb-0">KarasHuang</h5>
                  <p className="text-muted">後端工程師</p>
                  <p className="card-text">專注於後端系統開發，擅長設計高可靠性、高性能的應用程式介面。</p>
                  {/* <div className="social-icons">
                    <a href="#" className="text-dark mr-2"><i className="fab fa-linkedin-in"></i></a>
                    <a href="#" className="text-dark mr-2"><i className="fab fa-twitter"></i></a>
                    <a href="#" className="text-dark"><i className="fas fa-envelope"></i></a>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="card border-0 shadow h-100">
                <img
                  src={工程師3}
                  alt="全棧工程師"
                  className="card-img-top"
                />
                <div className="card-body text-center">
                  <h5 className="card-title mb-0">KarasHuang二號</h5>
                  <p className="text-muted">全端工程師</p>
                  <p className="card-text">前後端技術皆精通，能夠獨立完成各類型專案，解決複雜的技術挑戰。</p>
                  {/* <div className="social-icons">
                    <a href="#" className="text-dark mr-2"><i className="fab fa-linkedin-in"></i></a>
                    <a href="#" className="text-dark mr-2"><i className="fab fa-twitter"></i></a>
                    <a href="#" className="text-dark"><i className="fas fa-envelope"></i></a>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4">
              <div className="card border-0 shadow h-100">
                <img
                  src={工程師4}
                  alt="DevOps 工程師"
                  className="card-img-top"
                />
                <div className="card-body text-center">
                  <h5 className="card-title mb-0">CaesarAI</h5>
                  <p className="text-muted">Caesar Agent AI</p>
                  <p className="card-text">新人，不知道他在想什麼，但很聰明</p>
                  {/* <div className="social-icons">
                    <a href="#" className="text-dark mr-2"><i className="fab fa-linkedin-in"></i></a>
                    <a href="#" className="text-dark mr-2"><i className="fab fa-twitter"></i></a>
                    <a href="#" className="text-dark"><i className="fas fa-envelope"></i></a>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About; 